/**
 * @file Expression.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2022
 */

const exported = {
  /**
   * @function changeTreeAlias
   * @param {Array} child Child collection
   */
  createTreeAlias: function (child) {
    // return `expr_${child.join('_').slice(0, 63)}`
    return `expr_${child.reduce((a, b) => a + b, 0)}`
  },
  /**
   * @function getColumnName
   * @param {object} expression Expression instance
   * @param {string} aggregationType Aggregation type (count, sum, avg, max, min)
   * @returns {string} Returns a compatible expression name
   */
  getColumnName: function (expression, aggregationType = 'none') {
    // if (expression.hasOwnProperty('targetId') && expression.targetId === expression.id) return `${expression.name}`
    // if (expression.child == undefined || !Array.isArray(expression.child)) return `${expression.name}`
    const expressionId = expression.targetId || expression.id || expression.objectId
    if (expression.internalName != undefined && !expression.internalName.startsWith('expr')) return `expr_${expressionId}`
    if (aggregationType !== undefined && aggregationType !== null && aggregationType.value !== 'none') return expression.internalName
    return expression.internalName
  },
  /**
   * @function isNumericType
   * @param {object} expression Expression instance
   * @returns {boolean} Returns true, if is numeric. otherwise false
   */
  isNumericType: function (expression) {
    if (expression === null || typeof expression === 'undefined') return false
    if (Object.keys(expression.statisticalType).length === 0) return expression.statisticalType === 1
    return expression.statisticalType.key === 1
  },
  /**
   * @function isRestoreMode
   * @param {object} expression Target expression
   * @returns {boolean} Returns true, if are restored. otherwise false
   */
  isRestoreMode: function (expression) {
    if (expression === null || typeof expression === 'undefined' || Object.keys(expression).length === 0) return false
    return Object.hasOwn(expression, 'restore') && expression.restore === true
  },
  /**
   * @function isMultiCategory
   * @param expression Target expression
   * @param includeValues
   * @return {boolean} Returns true, if is multicategory. otherwise false
   */
  isMultiCategory: function (expression, includeValues = true) {
    if (expression === null) return false
    if (typeof expression !== 'object') throw new Error('Esperado um objeto: expression')
    if (expression.filterFormType !== 'multicategory') return false
    if (!includeValues) return true
    return Object.hasOwn(expression, 'selectObjects') && Object.keys(expression.selectObjects).length > 0
  },
  /**
   * @function isTreeView
   * @param expression Target expression
   * @param includeValues
   * @return {boolean} Returns true, if is treeview. otherwise false
   */
  isTreeView: function (expression, includeValues = true) {
    if (expression === null) return false
    if (typeof expression !== 'object') throw new Error('Esperado um objeto: expression')
    if (expression.filterFormType !== 'treeview') return false
    if (!includeValues) return true
    /*
    ! A expressão sempre ira passar [PK, expressionTreeview]
    */
    return Array.isArray(expression.child) && expression.child.length > 1
  },
  /**
   * @function searchParents
   * @param expression id expression
   * @param source
   * @return {boolean} Returns true, if is treeview. otherwise false
   */
  async searchParents(id, source) {

    let i = 0
    try {
      let self = this
      if (source === undefined) {
        return -1
      } else {


        for (i = 0; i < source.length; i++) {
          if (source[i].nId === id) {
            return source[i]
          } else {

            if (source[i].children === undefined || source[i].children.length === 0) return -1

            if (source[i].children.length > 0) {
              let result = await self.searchParents(id, source[i].children)
              if (result !== -1)
                return result
            }
          }
        }
        return -1
      }
    } catch (e) {
      console.error('Falha ao construir o Nome da Treeview')
      console.log(e)
      console.log(i)
      console.log(id)
      console.log(source)
    }
  },
  /**
   * @function correctOptions
   * @param options options from expression
   * @return {options} Returns options, with correct ids
   */
  correctOptions: function (options) {
    let num = 1
    for (var key in options) {
      options[key].id = num++
      for (var index in options[key].children) {
        options[key].children[index].id = num++
      }
    }
    return options
  },
  /**
   * @function getAliasTreeview
   * @param expression Target expression
   * @return {boolean} Returns true, if is treeview. otherwise false
   */
  getAliasTreeview: async function (expression) {
    console.log('#### buildAliasTreeview ####')
      let sourceTreeview = expression.treeSource
      let selectedChild = expression.selectedChild
      let self = this
      let parentList = []
      let countChildreen = []


      if(selectedChild != undefined) {
        for (let i = 0; i < selectedChild.length; i++) {
          if (!parentList.includes(selectedChild[i].nParentId))
            parentList.push(selectedChild[i].nParentId)

          countChildreen.push(selectedChild[i].nParentId)
        }
      }


      //Busca os Objetos Pais
      let oParents = []
      for (let i = 0; i < parentList.length; i++) {
        let idParent = parentList[i]
        let result = await self.searchParents(idParent, sourceTreeview)
        if (result !== undefined)
          if (result !== -1) {
            result.countC = 0
            oParents.push(result)
          }

      }

      let oParentList = []
      let countOrphan = 0

      //Remove os filhos encontrados se o Pai estiver na lista
      console.log('Removendo Childrens')
      for (let i = 0; i < oParents.length; i++) {
        let idParent = oParents[i].nParentId
        let id = oParents[i].nId
        oParents[i].bParentFullSelected = false
        let isChild = false
        for (let j = 0; j < oParents.length; j++) {
          let idTarget = oParents[j].nId
          if (id !== idTarget) {
            if (idParent === idTarget) {
              isChild = true
              oParents[j].countC += 1
            }
          }
        }

        let childrenOrphan = {}
        if(this.mode == 'pivot') {
          childrenOrphan = selectedChild
        } else {
          childrenOrphan = selectedChild.filter((item) => {
            return item.nParentId === id
          })
        }
        let childrenWithChildren = oParents.filter((item) => {
          return item.nParentId === id
        })



        if ((childrenOrphan.length + childrenWithChildren.length) === oParents[i].children.length) {
          oParents[i].bParentFullSelected = true
        } else {
          countOrphan += oParents[i].children.length
        }


        if (oParents[i].bParentFullSelected) {
          oParentList.push(oParents[i])

        }
      }

      let newList = []

      for (let i = 0; i < oParentList.length; i++) {

        let oFather = oParentList.filter((exp) => {
          return exp.nId === oParentList[i].nParentId
        })

        if (oFather.length === 0)
          newList.push(oParentList[i])
      }

      // Constroi o Alias
      let fullAlias = " "
      let countElements = 0
      for (let i = 0; i < newList.length; i++) {
        let parent = newList[i]
        if (parent.children.length > 0) {
          let count = countChildreen.filter((e) => {
            return e === parent.nId
          })

          if ((count.length + parent.countC) === parent.children.length) {
            fullAlias += ` (${parent.cAlias}) `
          } else {
            countElements += 1
          }
        }
      }

      if(selectedChild != undefined) {
        fullAlias += ` (+ ${selectedChild.length} itens) `
      }
      console.log('Alias Completo:')
      console.log(fullAlias)
      return fullAlias

  }
}

export default exported
